import FullWidthContainer from "./FullWidthContainer";
export default FullWidthContainer;
